"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoIdpProvider = exports.ProviderConfiguration = void 0;
var ProviderConfiguration;
(function (ProviderConfiguration) {
    ProviderConfiguration["ssoSaml"] = "ssoSaml";
    ProviderConfiguration["slack"] = "slack";
})(ProviderConfiguration || (exports.ProviderConfiguration = ProviderConfiguration = {}));
var SsoIdpProvider;
(function (SsoIdpProvider) {
    SsoIdpProvider["saml"] = "saml";
    // future implementation
    // okta = 'okta',
    // azureAd = 'azureAd',
})(SsoIdpProvider || (exports.SsoIdpProvider = SsoIdpProvider = {}));
//# sourceMappingURL=workspaceIntegration.js.map